import { ICaliperViewModel, IEcgMeasures, IMeasuresHandle, IMeasuresViewModel } from '../models/interfaces';

export class MeasuresHandle implements IMeasuresHandle {
    // data members

    private _measuresList = new Array<IMeasuresViewModel>();
    get measuresList() {
        return this._measuresList;
    }

    get count(): number {
        return this._measuresList.length;
    }

    // public functions

    select(caliper: ICaliperViewModel) {
        let measuresToSelect = this.measuresList.find(
            (measures) => measures.caliper == caliper && measures.caliper.title == caliper.title,
        );
        this.measuresList.forEach((measures) => (measures.selected = false));
        if (measuresToSelect) {
            measuresToSelect.selected = true;
        }
    }

    update(caliper: ICaliperViewModel, measures: IEcgMeasures) {
        let measuresToUpdate = this.measuresList.find(
            (measures) => measures.caliper == caliper && measures.caliper.title == caliper.title,
        );
        this.measuresList.forEach((measures) => (measures.selected = false));
        if (measuresToUpdate != null && measuresToUpdate != undefined) {
            measuresToUpdate.measures = measures;
            measuresToUpdate.selected = true;
        }
    }

    remove(caliper: ICaliperViewModel) {
        let measuresToRemove = this.measuresList.find(
            (measures) => measures.caliper == caliper && measures.caliper.title == caliper.title,
        );
        if (measuresToRemove != null && measuresToRemove != undefined) {
            measuresToRemove.selected = false;
            this.measuresList.splice(this.measuresList.indexOf(measuresToRemove), 1);
        }
    }

    clear() {
        this.measuresList.forEach((measures) => (measures.selected = false));
        this._measuresList = new Array<IMeasuresViewModel>();
    }
}
